import { FC } from 'react'
import Image from 'next/image'
import clsx from 'clsx'

import OriginLink from 'components/parts/originLink/originLink'
import BasicTag from 'components/tags/basic-tag/basic-tag'
import TagThemes from 'components/tags/basic-tag/themes'
import Lectors from '../new-webinar-card/lectors/lectors'
import Button from 'components/parts/button/button'

import { getCorrectDeclination } from './utils'
import { STATIC_URL } from 'constants/data'
import { ICourseNmoType } from 'constants/types/card.types'

import styles from './course-card-in-webinar.module.scss'

const CourseCardInWebinars: FC<ICourseNmoType> = ({
  name,
  points,
  Lecturs,
  lecturName,
  cardModificator,
  alreadyBought,
  urlBtn,
  isAbTest,
}) => {
  return (
    <div
      className={clsx(styles.card, {
        [cardModificator as string]: cardModificator,
        [styles.cardBlue]: isAbTest,
      })}
    >
      <div>
        <div className={styles.headerWrap}>
          <div className={styles.header}>
            <BasicTag themeColor={TagThemes.YELLOW}>
              <>{points} НМО</>
            </BasicTag>

            <BasicTag uppercase={false} themeColor={TagThemes.PINK}>
              Курс НМО
            </BasicTag>
          </div>
        </div>
        <p
          className={clsx(styles.title, {
            [styles.titleBlue]: isAbTest,
          })}
        >
          {name}
        </p>
        <div className={styles.footer}>
          {!!Lecturs?.length && (
            <div className={styles.lectur}>
              <Lectors Lecturs={Lecturs} lecturName={lecturName} isDark={isAbTest} />
            </div>
          )}
          <div className={styles.bottomWrapper}>
            {!!alreadyBought && (
              <div className={styles.statWrapper}>
                <Image
                  src={`${STATIC_URL}/icons/icon_done.svg`}
                  alt={'Галочка'}
                  width={18}
                  height={18}
                />
                <p className={styles.statCounter}>{getCorrectDeclination(alreadyBought)}</p>
              </div>
            )}
            <div className={clsx(styles.btnWrapper)}>
              <OriginLink href={urlBtn}>
                <Button>
                  <span>Программа курса</span>
                </Button>
              </OriginLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CourseCardInWebinars
